import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Context Providers
import { AuthProvider, useAuth } from './components/authentication_components/authContext';
import { AdminRegistrationProvider } from './components/authentication_components/adminRegistrationContext';
import { BusinessDataProvider } from './components/authentication_components/businessDataContext';
import { BusinessChangeLogsProvider } from './components/authentication_components/businessChangeContext';
import { BusinessProductProvider } from './components/authentication_components/businessProductContext';
import { BusinessEmployeeProvider } from './components/authentication_components/businessEmployeeContext';
import { BusinessServiceProvider } from './components/authentication_components/businessServiceContext';
import { BusinessEventProvider } from './components/authentication_components/businessEventContext';
import { EventIntervalProvider } from './components/authentication_components/eventIntervalContext';
import { BusinessSubscriptionProvider } from './components/authentication_components/businessSubscriptionContext';
import { SubscriptionTrialProvider } from './components/authentication_components/subscriptionTrialContext';
import { BusinessAccessProvider } from './components/authentication_components/businessAccessContext';
import { BusinessRegistrationProvider } from './components/authentication_components/businessRegistrationContext';
import { BusinessLocationProvider } from './components/authentication_components/businessLocationContext';
import { MobileLocationProvider } from './components/authentication_components/businessMobileLocationContext';
import { EmailChangeProvider } from './components/authentication_components/emailChangeContext';
import { QRScansProvider } from './components/authentication_components/businessScansScontext';
import { NatureMetaProvider } from './components/authentication_components/natureMetaContext';
import { ViatorExperienceProvider } from './components/authentication_components/viatorExperienceContext';
import { EmailVerificationProvider } from './components/authentication_components/emailverificationCodeContext';
import { SMSRelayProvider } from './components/authentication_components/phoneVerificationContext';
import { LocationCoordinateProvider } from './components/authentication_components/locationCoordinateContext';
import { BusinessVerificationProvider } from './components/authentication_components/adminVerificationContext';
import { BusinessDeletionProvider } from './components/authentication_components/businessDeletionContext';
import { EventImagesProvider } from './components/authentication_components/eventImagesContext';
import { LocationSubmissionsProvider } from './components/authentication_components/LocationSubmissionContext';
import { LocationGallerySubmissionProvider } from './components/authentication_components/locationGallerySubmissionContext';
import { BusinessEditsProvider } from './components/authentication_components/businessEditContext';
import { BusinessSubmissionsProvider } from './components/authentication_components/BusinessSubmissionContext';
import { UserReportsProvider } from './components/authentication_components/userReportContext';
import { BusinessRestrictionsProvider } from './components/authentication_components/prlocalRestrictionContext';
import { PrlocalBusinessDataProvider } from './components/authentication_components/prlocalBusinessDataContext';
import { BusinessPublicToggleProvider } from './components/authentication_components/businessPublicToggleContext';
import { AdminTrackerProvider } from './components/authentication_components/adminTrackerContext';
import { PrlocalMetricsProvider } from './components/authentication_components/prlocalMetricsContext';
import { RouteModerationProvider } from './components/authentication_components/routeModerationContext';
import { BusinessScheduleProvider } from './components/authentication_components/businessScheduleContext';
import { BusinessGalleryProvider } from './components/authentication_components/businessGalleryContext';
import { BusinessSocialsProvider } from './components/authentication_components/businessSocialsContext'
import { ContactSubmissionsProvider } from './components/authentication_components/ContactSubmissionsContext';
import { NavelaProvider } from './components/authentication_components/navelaContext';
import { QRCreateProvider } from './components/authentication_components/qrCreateContext';
import { AutoLeyProvider } from './components/authentication_components/autoleyContext';

// Login & Portal
import AdminLogin from './components/login_components/admin_login';
import PortalPage from './components/portal_components/portal_component';

// ==========================================
// JAYDEVS COMPONENTS
// ==========================================
import AdminDashboard from './components/Jaydevspr_components/dashboard_components/admin_dashboard';
import BusinessContent from './components/Jaydevspr_components/dashboard_components/business_content';
import BusinessRegistration from './components/Jaydevspr_components/dashboard_components/business_registration';
import ManageAccess from './components/Jaydevspr_components/dashboard_components/business_access';
import ManageSubscriptions from './components/Jaydevspr_components/dashboard_components/business_subscriptions';
import AdminRegistration from './components/Jaydevspr_components/registration_components/admin_registration';
import AdminRegistrationHistory from './components/Jaydevspr_components/registration_components/admin_registration_history';
import AdminApproval from './components/Jaydevspr_components/registration_components/admin_approval';
import QRScansManager from './components/Jaydevspr_components/QR_scans_components/QRScansManager';
import ContactSubmissions from './components/Jaydevspr_components/dashboard_components/contact_submissions';
import JaydevsHeaderBar from './components/Jaydevspr_components/constant_components/header_bar';

// ==========================================
// PR LOCAL COMPONENTS (NEW)
// ==========================================
import PRLocalHeaderBar from './components/PRlocal_components/constant_components/header_bar';
import PRLocalBusinesses from './components/PRlocal_components/dashboard_components/prlocal_businesses';
import PRLocalReports from './components/PRlocal_components/dashboard_components/business_reports';
import PRLocalContentManager from './components/PRlocal_components/dashboard_components/business_content';
import PRLocalLocationSubmissions from './components/PRlocal_components/dashboard_components/location_submissions';
import PRLocalGallerySubmission from './components/PRlocal_components/dashboard_components/gallery_submissions';
import PRLocalBusinessSubmissions from './components/PRlocal_components/dashboard_components/business_suggestions';
import NatureMetaPage from './components/PRlocal_components/dashboard_components/nature_metadata';
import ViatorExperiencesPage from './components/PRlocal_components/dashboard_components/viator_experiences';
import PRLocalUsageMetrics from './components/PRlocal_components/dashboard_components/usage_metrics';
import PRLocalRouteModeration from './components/PRlocal_components/dashboard_components/route_moderation';

// ==========================================
// NAVELA COMPONENTS (NEW)
// ==========================================
import NavelaDashboard from './components/Navela_components/dashboard_components/navela_dashboard';

// ==========================================
// QR CREATE COMPONENTS (NEW)
// ==========================================
import QRCreateDashboard from './components/QRCreate_components/dashboard_components/qrcreate_dashboard';

// ==========================================
// AUTOLEY COMPONENTS (NEW)
// ==========================================
import AutoLeyDashboard from './components/AutoLey_components/dashboard_components/autoley_dashboard';

import { Toaster } from 'react-hot-toast';
import { Shield, AlertTriangle, Lock } from 'lucide-react';
import './App.css';


// Protected Route Component
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-50 to-orange-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-orange-500 border-t-transparent mx-auto mb-4"></div>
          <p className="text-gray-600">Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

// Master Guard Component - Only allows master users
function MasterGuard({ children, fallbackMessage, showWarning = true }) {
  const { loginType, user } = useAuth();

  if (loginType !== 'master') {
    return (
      <div className="bg-gradient-to-br from-red-50 to-orange-50 min-h-screen flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 border border-red-200">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
              <Lock className="h-8 w-8 text-red-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Acceso Restringido
            </h2>
            <p className="text-gray-600 mb-6">
              {fallbackMessage || 'Esta función requiere permisos de nivel maestro para acceder.'}
            </p>
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <div className="flex items-center justify-center space-x-2 text-sm text-gray-600">
                <Shield className="h-4 w-4" />
                <span>Usuario actual: {user?.email || 'Admin'}</span>
              </div>
              <div className="text-xs text-gray-500 mt-1">
                Nivel de acceso: Administrador
              </div>
            </div>
            {showWarning && (
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
                <div className="flex items-start space-x-2">
                  <AlertTriangle className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <div className="text-left">
                    <p className="text-sm font-medium text-amber-800 mb-1">
                      Acceso de Nivel Maestro Requerido
                    </p>
                    <p className="text-xs text-amber-700">
                      Solo usuarios con credenciales maestras pueden acceder a esta funcionalidad.
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className="space-y-3">
              <button
                onClick={() => window.history.back()}
                className="w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-lg transition-colors"
              >
                Volver Atrás
              </button>
              <button
                onClick={() => window.location.href = '/admin-dashboard'}
                className="w-full bg-orange-500 hover:bg-orange-600 text-white font-medium py-2 px-4 rounded-lg transition-colors"
              >
                Ir al Dashboard Principal
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return children;
}

// Admin Guard Component
function AdminGuard({ children }) {
  const { loginType, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (loginType !== 'admin' && loginType !== 'master') {
    return (
      <div className="bg-gradient-to-br from-red-50 to-orange-50 min-h-screen flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 border border-red-200">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
              <Shield className="h-8 w-8 text-red-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Acceso de Administrador Requerido
            </h2>
            <p className="text-gray-600 mb-6">
              Esta función requiere permisos de administrador para acceder.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="w-full bg-orange-500 hover:bg-orange-600 text-white font-medium py-2 px-4 rounded-lg transition-colors"
            >
              Volver al Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
}

// =================================================================
// PR LOCAL DASHBOARD LAYOUT COMPONENT
// =================================================================
function PRLocalDashboardLayout() {
  const [activeTab, setActiveTab] = useState('registered_businesses');

  const renderContent = () => {
    switch (activeTab) {
      case 'registered_businesses':
        return <PRLocalBusinesses />;
      case 'business_reports':
        return <PRLocalReports />;
      case 'route_moderation':
        return <PRLocalRouteModeration />;
      case 'content_manager':
        return <PRLocalContentManager />;
      case 'location_submissions':
        return <PRLocalLocationSubmissions />;
      case 'business_submissions':
        return <PRLocalBusinessSubmissions />;
      case 'gallery_submissions':
        return <PRLocalGallerySubmission />;
      case 'nature_meta':
        return <NatureMetaPage />;
      case 'viator_experiences':
        return <ViatorExperiencesPage />;
      case 'usage_metrics':
        return <PRLocalUsageMetrics />;
      default:
        return <PRLocalBusinesses />;
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
      <PRLocalHeaderBar activeTab={activeTab} onTabChange={setActiveTab} />
      <div className="fade-in-enter-active">
        {renderContent()}
      </div>
    </div>
  );
}


// Main App Component with Auth Context
function AppContent() {
  const [activeTab, setActiveTab] = useState('search');
  const { isAuthenticated } = useAuth();

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  // Render logic for Jaydevs Dashboard
  const renderActiveTabContent = () => {
    switch (activeTab) {
      case 'search':
        return (
          <BusinessDataProvider>
            <BusinessChangeLogsProvider>
              <EmailChangeProvider>
                <BusinessPublicToggleProvider>
                  <SMSRelayProvider>
                    <MobileLocationProvider>
                      <BusinessEditsProvider>
                        <BusinessRegistrationProvider>
                          <BusinessScheduleProvider>
                            <BusinessSocialsProvider>
                              <AdminDashboard />
                            </BusinessSocialsProvider>
                          </BusinessScheduleProvider>
                        </BusinessRegistrationProvider>
                      </BusinessEditsProvider>
                    </MobileLocationProvider>
                  </SMSRelayProvider>
                </BusinessPublicToggleProvider>
              </EmailChangeProvider>
            </BusinessChangeLogsProvider>
          </BusinessDataProvider>
        );
      case 'content':
        return (
          <BusinessDataProvider>
            <BusinessLocationProvider>
              <MobileLocationProvider>
                <BusinessGalleryProvider>
                  <EventImagesProvider>
                    <BusinessProductProvider>
                      <BusinessEmployeeProvider>
                        <BusinessServiceProvider>
                          <QRScansProvider>
                            <BusinessEventProvider>
                              <EventIntervalProvider>
                                <BusinessContent />
                              </EventIntervalProvider>
                            </BusinessEventProvider>
                          </QRScansProvider>
                        </BusinessServiceProvider>
                      </BusinessEmployeeProvider>
                    </BusinessProductProvider>
                  </EventImagesProvider>
                </BusinessGalleryProvider>
              </MobileLocationProvider>
            </BusinessLocationProvider>
          </BusinessDataProvider>
        );
      case 'subscriptions':
        return (
          <BusinessDataProvider>
            <BusinessSubscriptionProvider>
              <SubscriptionTrialProvider>
                <ManageSubscriptions />
              </SubscriptionTrialProvider>
            </BusinessSubscriptionProvider>
          </BusinessDataProvider>
        );
      case 'access':
        return (
          <BusinessDataProvider>
            <BusinessAccessProvider>
              <ManageAccess />
            </BusinessAccessProvider>
          </BusinessDataProvider>
        );
      case 'register':
        return (
          <BusinessDataProvider>
            <BusinessRegistrationProvider>
              <EmailVerificationProvider>
                <LocationCoordinateProvider>
                  <BusinessRegistration />
                </LocationCoordinateProvider>
              </EmailVerificationProvider>
            </BusinessRegistrationProvider>
          </BusinessDataProvider >
        );

      case 'qr-scans':
        return (
          <BusinessDataProvider>
            <QRScansManager />
          </BusinessDataProvider>
        );

      case 'contact-submissions':
        return (
          <BusinessDataProvider>
            <ContactSubmissions />
          </BusinessDataProvider>
        );
      case 'admin-registration':
        return (
          <MasterGuard fallbackMessage="El registro de nuevos administradores requiere acceso de nivel maestro.">
            <AdminRegistrationProvider>
              <AdminRegistration />
            </AdminRegistrationProvider>
          </MasterGuard>
        );
      case 'admin-approval':
        return (
          <MasterGuard fallbackMessage="La aprobación de administradores requiere acceso de nivel maestro.">
            <AdminRegistrationProvider>
              <AdminApproval />
            </AdminRegistrationProvider>
          </MasterGuard>
        );

      default:
        return (
          <BusinessDataProvider>
            <BusinessLocationProvider>
              <MobileLocationProvider>
                <BusinessEditsProvider>
                  <BusinessChangeLogsProvider>
                    <BusinessRegistrationProvider>
                      <BusinessScheduleProvider>
                        <AdminDashboard />
                      </BusinessScheduleProvider>
                    </BusinessRegistrationProvider>
                  </BusinessChangeLogsProvider>
                </BusinessEditsProvider>
              </MobileLocationProvider>
            </BusinessLocationProvider>
          </BusinessDataProvider>
        );
    }
  };

  return (
    <Routes>
      {/* Login route */}
      <Route path="/" element={
        isAuthenticated ? <Navigate to="/portal" replace /> : <AdminLogin />
      } />

      {/* Portal Route */}
      <Route
        path="/portal"
        element={
          <ProtectedRoute>
            <AdminGuard>
              <PortalPage />
            </AdminGuard>
          </ProtectedRoute>
        }
      />

      {/* ========================================================= */}
      {/* NEW ROUTE: PR LOCAL ADMIN DASHBOARD                       */}
      {/* ========================================================= */}
      <Route
        path="/prlocal/admin-dashboard"
        element={
          <ProtectedRoute>
            <AdminGuard>
              <PrlocalBusinessDataProvider>
                <BusinessVerificationProvider>
                  <BusinessDeletionProvider>
                    <BusinessEditsProvider>
                      <NatureMetaProvider>
                        <LocationSubmissionsProvider>
                          <LocationGallerySubmissionProvider>
                            <BusinessSubmissionsProvider>
                              <BusinessRestrictionsProvider>
                                <ViatorExperienceProvider>
                                  <PrlocalMetricsProvider>
                                    <RouteModerationProvider>
                                      <UserReportsProvider> {/* Wraps the layout to cover Reports */}
                                        <PRLocalDashboardLayout />
                                      </UserReportsProvider>
                                    </RouteModerationProvider>
                                  </PrlocalMetricsProvider>
                                </ViatorExperienceProvider>
                              </BusinessRestrictionsProvider>
                            </BusinessSubmissionsProvider>
                          </LocationGallerySubmissionProvider>
                        </LocationSubmissionsProvider>
                      </NatureMetaProvider>
                    </BusinessEditsProvider>
                  </BusinessDeletionProvider>
                </BusinessVerificationProvider>
              </PrlocalBusinessDataProvider>
            </AdminGuard>
          </ProtectedRoute>
        }
      />

      {/* ========================================================= */}
      {/* NEW ROUTE: NAVELA FLEET ADMIN DASHBOARD                   */}
      {/* ========================================================= */}
      <Route
        path="/navela/admin-dashboard"
        element={
          <ProtectedRoute>
            <AdminGuard>
              <NavelaProvider>
                <NavelaDashboard />
              </NavelaProvider>
            </AdminGuard>
          </ProtectedRoute>
        }
      />

      {/* ========================================================= */}
      {/* NEW ROUTE: QR CREATE OPERATOR DASHBOARD                   */}
      {/* ========================================================= */}
      <Route
        path="/qrcreate/admin-dashboard"
        element={
          <ProtectedRoute>
            <AdminGuard>
              <QRCreateProvider>
                <QRCreateDashboard />
              </QRCreateProvider>
            </AdminGuard>
          </ProtectedRoute>
        }
      />

      {/* ========================================================= */}
      {/* NEW ROUTE: AUTOLEY LICENSE SUPPORT DASHBOARD              */}
      {/* ========================================================= */}
      <Route
        path="/autoley/admin-dashboard"
        element={
          <ProtectedRoute>
            <AdminGuard>
              <AutoLeyProvider>
                <AutoLeyDashboard />
              </AutoLeyProvider>
            </AdminGuard>
          </ProtectedRoute>
        }
      />

      {/* ========================================================= */}
      {/* EXISTING JAYDEVS ROUTES                                   */}
      {/* ========================================================= */}
      <Route
        path="/jaydevspr/admin-dashboard"
        element={
          <ProtectedRoute>
            <AdminGuard>
              <BusinessVerificationProvider>
                <BusinessDeletionProvider>
                  <QRScansProvider>
                    <div>
                      <JaydevsHeaderBar
                        activeTab={activeTab}
                        onTabChange={handleTabChange}
                      />
                      {renderActiveTabContent()}
                    </div>
                  </QRScansProvider>
                </BusinessDeletionProvider>
              </BusinessVerificationProvider>
            </AdminGuard>
          </ProtectedRoute>
        }
      />

      {/* Legacy direct links support (Optional, redirects to dashboard with correct tab) */}
      <Route
        path="/jaydevspr/business-data"
        element={
          <ProtectedRoute>
            <AdminGuard>
              <Navigate to="/jaydevspr/admin-dashboard" replace />
            </AdminGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/jaydevspr/business-registrations"
        element={
          <ProtectedRoute>
            <AdminGuard>
              <Navigate to="/jaydevspr/admin-dashboard" replace />
            </AdminGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/jaydevspr/admin-registration-history"
        element={
          <ProtectedRoute>
            <MasterGuard fallbackMessage="El historial de registros requiere acceso de nivel maestro.">
              <AdminRegistrationProvider>
                <AdminRegistrationHistory />
              </AdminRegistrationProvider>
            </MasterGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/jaydevspr/master/admin-registration"
        element={
          <ProtectedRoute>
            <MasterGuard>
              <div>
                <JaydevsHeaderBar
                  activeTab="admin-registration"
                  onTabChange={handleTabChange}
                />
                <AdminRegistrationProvider>
                  <AdminRegistration />
                </AdminRegistrationProvider>
              </div>
            </MasterGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/jaydevspr/master/qr-scans"
        element={
          <ProtectedRoute>
            <MasterGuard>
              <QRScansProvider>
                <div>
                  <QRScansManager
                    activeTab="qr-scans"
                    onTabChange={handleTabChange}
                  />
                </div>
              </QRScansProvider>
            </MasterGuard>
          </ProtectedRoute>
        }
      />

      <Route
        path="/jaydevspr/admin-approval"
        element={
          <ProtectedRoute>
            <MasterGuard>
              <AdminRegistrationProvider>
                <AdminApproval />
              </AdminRegistrationProvider>
            </MasterGuard>
          </ProtectedRoute>
        }
      />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/jaydevspr/admin-dashboard" replace />} />
    </Routes>
  );
}

// Root App Component
function App() {
  return (
    <AuthProvider>
      <Router>
        <AdminTrackerProvider>
          <div className="App">
            <AppContent />
          </div>
        </AdminTrackerProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;